import { MAP_TYPES } from '@deck.gl/carto';
 
const TSN_HISTORICAL_RAMP_SOURCE_ID = 'tsnHistoricalRampSource';
 
const source = {
  id: TSN_HISTORICAL_RAMP_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  data: 'tsn_historical_ramp',
};
 
export default source;
 